import { type AxiosInstance } from 'axios';
import { get } from 'lodash';
import type QueryString from 'qs';
import {
  AsyncServiceMethod,
  type IAsyncService,
} from '../context/IAsyncService.ts';
import { asyncServiceMapResults } from './asyncServiceMapResults.ts';

export async function fetchAsyncService(input: {
  service: IAsyncService;
  url: string;
  originalParams: QueryString.ParsedQs;
  httpClient: AxiosInstance;
  params: any;
  /** Permette di annullare la richiesta quando non è più necessaria */
  signal?: AbortSignal;
}) {
  const { service, url, originalParams, httpClient, params, signal } = input;

  const response = await httpClient({
    url,
    method: service.method,
    params:
      // GET
      service.method === AsyncServiceMethod.GET
        ? { ...originalParams, ...params }
        : // Gli originalParams vengono direttamente dall'URL, quindi vanno sempre qui
          originalParams,
    data:
      // POST-PUT
      service.method !== AsyncServiceMethod.GET ? params : undefined,
    signal,
  });

  // `apiClient` di `@framework/api-client` restituisce la AxiosResponse,
  // che contiene i dati nel campo `data`
  const data = response?.data;

  const resultData = service.outputRoot ? get(data, service.outputRoot) : data;

  if (Array.isArray(resultData)) {
    return resultData.map(item => asyncServiceMapResults(item, service));
  }
  return asyncServiceMapResults(resultData, service);
}
